import { render, staticRenderFns } from "./printing_type.vue?vue&type=template&id=3b804995&"
import script from "./printing_type.vue?vue&type=script&lang=js&"
export * from "./printing_type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports